import type * as lazyFunctions from './lazyFunctions';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';
export type { NativeHostPostBootUserInformationGetters } from './setupNativeHostPostBoot';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule(
    () => import(/* webpackChunkName: "AppBootNativePostBoot" */ './lazyFunctions'),
    { name: 'AppBootNativePostBoot' }
);

export const lazySetupNativeHostPostBoot: LazyAction<
    typeof lazyFunctions.lazySetupNativeHostPostBoot.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazySetupNativeHostPostBoot.importAndExecute);
